
import React, { useEffect, useState } from 'react';

import Dropdown from '../../../components/Dropdown';
import Label from '../../../components/forms/Label';

interface EmailDropdownProps {
  id: string;
  email: string;
  error: boolean;
  setEmail: (email: string) => void;
  emailList: string[];
}

export type DropdownOption<T> = {
  value: T,
  text: string,
};

const EmailDropdown: React.FC<EmailDropdownProps> = ({
  id,
  email,
  error,
  setEmail,
  emailList,
}) => {
  const [placeholder, setPlaceholder] = useState<string | undefined>();
  const [value, setValue] = useState<string | undefined>();
  const options: DropdownOption<string>[] = emailList.map(emailListItem => ({
    value: emailListItem,
    text: emailListItem,
  }));

  const isEmailListEmpty = !emailList.length;

  useEffect(() => {
    const newValue = (emailList.includes(email) && email) || '';
    setValue(newValue);
    if (!newValue) {
      setPlaceholder(email || 'Please Select an Email Address');
    }
  }, [email, emailList]);

  const onChangeHandler = (value: string | number | readonly string[] | undefined) => {
    if (value) {
      setEmail(value as string);
    }
  };

  return (
    <>
      {/* this outer div doesn't look necessary, but it's to copy the layout of the domain input so spacing of the tooltip works */}
      <div>
        <Label htmlFor="domainSelector" text="Email:" />
        <Dropdown
          id={id}
          placeholder={placeholder}
          value={value}
          error={error}
          options={options}
          onChange={onChangeHandler}
          disabled={isEmailListEmpty}
        />
      </div>
    </>
  );
};

export default EmailDropdown;
